import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAreaFuture = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Frame",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M18.6667 9.33333C18.6667 10.8061 17.4728 12 16 12C14.5272 12 13.3333 10.8061 13.3333 9.33333C13.3333 7.86057 14.5272 6.66667 16 6.66667C17.4728 6.66667 18.6667 7.86057 18.6667 9.33333Z",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M3.95184 21.7187C3.1278 19.9856 2.66667 18.0467 2.66667 16C2.66667 8.6362 8.6362 2.66667 16 2.66667C23.3637 2.66667 29.3333 8.6362 29.3333 16C29.3333 23.3637 23.3637 29.3333 16 29.3333C14.1037 29.3333 12.2999 28.9375 10.6667 28.2239M3.95184 21.7187C3.1814 22.1861 2.66667 23.0329 2.66667 24C2.66667 25.4728 3.86057 26.6667 5.33333 26.6667C6.02964 26.6667 6.66361 26.3997 7.13856 25.9628C7.66816 25.4753 8 24.7764 8 24C8 22.5272 6.80609 21.3333 5.33333 21.3333C4.8276 21.3333 4.35475 21.4741 3.95184 21.7187Z",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M17.5899 22.4759C18.0177 23.3771 18.9361 24 20 24C21.4728 24 22.6667 22.8061 22.6667 21.3333C22.6667 20.5403 22.3205 19.8281 21.7711 19.3397C21.3001 18.9211 20.6797 18.6667 20 18.6667C18.5272 18.6667 17.3333 19.8605 17.3333 21.3333C17.3333 21.7423 17.4253 22.1296 17.5899 22.4759ZM21.7711 19.3397C22.3407 18.3577 22.6667 17.2169 22.6667 16C22.6667 14.7857 22.342 13.6472 21.7748 12.6667M17.5899 22.4759C17.0804 22.6005 16.5479 22.6667 16 22.6667C12.3181 22.6667 9.33333 19.6819 9.33333 16C9.33333 14.7857 9.65799 13.6472 10.2252 12.6667",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinecap: "round"
			})
		]
	})
});
export default SvgAreaFuture;
